import { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { trackWhatsAppOpen, trackWhatsAppSend } from "@/lib/analytics";

const NUMBER = "971508003202"; // international, no + or spaces
const DEFAULT_MSG =
  "Hi MJ, I'd like to discuss a sourcing brief for [category]. When can we connect?";

export default function WhatsAppWidget() {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState(DEFAULT_MSG);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(t);
  }, []);

  const href = `https://wa.me/${NUMBER}?text=${encodeURIComponent(msg)}`;

  return (
    <div
      className={
        "fixed z-50 bottom-6 right-6 md:bottom-8 md:right-8 transition-all duration-500 " +
        (visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none")
      }
      data-testid="whatsapp-widget"
    >
      {open ? (
        <div className="w-[320px] bg-nx-bg border border-nx-navy shadow-[6px_6px_0_#1B3D6E]">
          <div className="flex items-center justify-between bg-nx-navy text-nx-bg px-4 py-3">
            <div>
              <div className="font-cabinet font-black text-sm tracking-tight leading-none">
                MJ Gill
              </div>
              <div className="font-mono text-[0.6rem] uppercase tracking-[0.2em] text-nx-steel mt-1">
                Sourcing Desk · WhatsApp
              </div>
            </div>
            <button
              onClick={() => setOpen(false)}
              className="text-nx-bg/80 hover:text-nx-bg"
              aria-label="Close chat"
              data-testid="whatsapp-close"
            >
              <X size={16} />
            </button>
          </div>
          <div className="p-4 space-y-3">
            <p className="text-xs text-nx-navy2 leading-relaxed">
              Message goes to MJ directly. Replace the bracketed placeholders and send:
            </p>
            <textarea
              value={msg}
              onChange={(e) => setMsg(e.target.value)}
              rows={5}
              className="w-full text-sm border border-nx-navy/40 focus:border-nx-navy p-2 outline-none font-ibm text-nx-navy resize-none"
              data-testid="whatsapp-message"
            />
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-send"
              onClick={() => trackWhatsAppSend()}
              className="nx-btn w-full justify-center"
            >
              <MessageCircle size={14} /> Send on WhatsApp
            </a>
          </div>
        </div>
      ) : (
        <button
          onClick={() => { setOpen(true); trackWhatsAppOpen(); }}
          data-testid="whatsapp-open"
          className="group flex items-center gap-3 bg-nx-navy text-nx-bg pl-4 pr-5 py-3 border border-nx-navy hover:bg-nx-bg hover:text-nx-navy transition-[background,color,transform] duration-300 hover:-translate-y-0.5 hover:-translate-x-0.5 shadow-[4px_4px_0_#1B3D6E]"
        >
          <MessageCircle size={18} strokeWidth={2} />
          <span className="font-mono text-[0.7rem] uppercase tracking-[0.14em]">
            Chat with MJ
          </span>
        </button>
      )}
    </div>
  );
}
